export interface RouteSegmentLike {
  path: string;
}

export interface RoutePathNodeLike {
  snapshot: {
    url: RouteSegmentLike[];
  };
  firstChild?: RoutePathNodeLike | null;
}

export interface OutletRouteNodeLike extends RoutePathNodeLike {
  outlet: string;
}

export function collectRoutePathSegments(route: RoutePathNodeLike | null | undefined): string[] {
  const segments: string[] = [];
  let currentRoute = route ?? null;

  while (currentRoute) {
    segments.push(...(currentRoute.snapshot.url || []).map(segment => segment.path).filter(Boolean));
    currentRoute = currentRoute.firstChild ?? null;
  }

  return segments;
}

export function getCanvasOutletPathFromChildren(children: ReadonlyArray<OutletRouteNodeLike>): string {
  const canvasRoute = children.find(child => child.outlet === 'canvasOutlet');
  return collectRoutePathSegments(canvasRoute).join('/');
}
